export { default } from './create-change-indicated-component';
